type TriggerResponse = {
    counter: string,
    min_date: string | null,
    max_date: string | null,
    cur_date: string | null,
    min: string,
    max: string,
    cur: string,
    max_is_new_counter: boolean
};

enum mState {noMessage, outOfRange, bevorFirstReading, newCounter}

type CounterMap = Map<string, Counter>;
type FormMap = Map<string, CounterForm>;

window.formCounterMap = new Map;


window.addEventListener('load', () => {
    const counterElements: NodeListOf<HTMLFormElement> = document.querySelectorAll('[data-bm-counter]');
    counterElements.forEach((form) => {

        if (!(form instanceof HTMLFormElement))
            throw `${form} is not an FormElement`;

        if (!window.formCounterMap.has(form.name))
            window.formCounterMap.set(form.name, new CounterForm(form));
    });
});

class CounterForm {
    private readonly form: HTMLFormElement;
    private readonly triggers: NodeListOf<HTMLInputElement | HTMLSelectElement>;
    private counters: CounterMap = new Map;
    private formData: any;

    constructor(element: HTMLFormElement) {
        this.form = element;
        if (!this.form) {
            throw `${element.name} is not in a form`;
        }

        this.triggers = this.form.querySelectorAll('[data-bm-trigger="counter"]');
        this.triggers.forEach((element) => {
            element.addEventListener('blur', () => this.setCounterBoundaries());
        });
        const counters: NodeListOf<HTMLInputElement> = this.form.querySelectorAll('[data-bm-triggered="counter"]');
        counters.forEach((element) => {
            if (!this.counters.has(element.name))
                this.counters.set(element.name, new Counter(element));
        });
    }

    show(event: string, args: unknown) {
        // console.log(event, args)
    }

    setFormData(formData: any) {
        this.formData = formData;
    }

    getFormData(): any {
        return this.formData;
    }

    setCounterBoundaries() {
        this.fetchData()
            .then(res => res.json())
            .then(response => {
                if (!response.data.length)
                    throw `could not fetch data`;

                this.setData(JSON.parse(response.data))

            })
            .catch(reason => {
                console.error('Request failed', reason);
            });
    }

    async fetchData() {
        if (!this.form.dataset.bmCounter)
            throw `counter form has no target URL`;
        let formData = new FormData(this.form);
        formData.set('name', this.form.name);
        return fetch(this.form.dataset.bmCounter, {method: 'POST', body: formData});
    }

    setData(results: TriggerResponse[]) {
        results.forEach((result) => {
            // const element = this.form.querySelector('[data-bm-triggered="counter"][name*="' + result.counter + '"]') as HTMLInputElement;
            let counter = this.counters.get(result.counter);
            if (!counter)
                throw 'counter ' + result.counter + ' not found';

            counter.setDataAttributes(result);
        });
    }

    getCounters() {
        return this.counters;
    }
}

class Counter {

    private readonly colWidth: number;
    private readonly counter: HTMLInputElement | null;
    private readonly form: HTMLFormElement | null;
    private readonly formName: string | null;
    private readonly counterName: string | null;
    private readonly formDate: HTMLInputElement;
    private readonly formSubmit: HTMLButtonElement;
    private readonly inputFrame: HTMLDivElement;
    private readonly inputWrapper: HTMLDivElement;
    private readonly newCounter: HTMLDivElement;
    private readonly newCounterInput: HTMLInputElement;
    private valid: boolean = true;
    private min: number = 0;
    private max: number = 0;
    private cur: number = 0;
    private minDate: Date | null = null;
    private maxDate: Date | null = null;
    private curDate: Date | null = null;
    private maxIsNewCounter: boolean = false;
    private messageState: mState = mState.noMessage;
    private counterValue: number | null = null;
    private message: HTMLDivElement | null = null;


    constructor(element: HTMLInputElement) {
        this.counter = element;
        this.form = element.form;
        if (!this.form)
            throw `${this.form} is not set`;

        this.colWidth = 4;
        if (this.form.dataset.colWidth)
            this.colWidth = parseInt(this.form.dataset.colWidth);

        this.formName = this.form.name;
        this.formDate = this.form.querySelector('[type="date"]') as HTMLInputElement;
        this.formSubmit = this.form.querySelector('[type="submit"]') as HTMLButtonElement;
        this.inputFrame = this.counter.closest('div.row') as HTMLDivElement;
        this.inputWrapper = this.counter.closest('div') as HTMLDivElement;
        this.newCounter = this.inputFrame.querySelector('div.newCounterWrapper') as HTMLDivElement;
        this.newCounterInput = this.newCounter.querySelector('input') as HTMLInputElement;
        this.message = this.inputFrame.querySelector('.message');
        this.counterName = this.counter.name.replace(this.formName + '[', '').replace(']', '');

        if (!this.message)
            this.createMessage();

        this.counter.addEventListener('focus', () => this.removeMessage());
        this.counter.addEventListener('change', () => this.checkReading());
        this.counter.addEventListener('blur', () => this.checkReading());

        this.toggleSubmitDisabled();
    }

    show(event: string, args: unknown) {

    }

    checkReading() {
        this.removeMessage();
        if (!this.counter)
            return;
        let check = false;
        this.counterValue = parseInt(this.counter.value);
        const formDate: Date = new Date(this.formDate.value + 'T00:00:00');

        if (
            this.minDate
            && this.minDate < formDate
            && this.maxDate
            && this.maxDate > formDate
            && this.counterValue != null
            && ((this.min >= 0 && this.counterValue < this.min)
                || (this.max > 0 && this.counterValue > this.max)
            )
            && !this.maxIsNewCounter
        ) {
            this.messageState = mState.outOfRange;
            check = true;
        }

        if (this.min == 0 && this.max == 0) {
            const refDate: Date | null = this.minDate ?? this.maxDate ?? null;

            if (refDate && formDate <= refDate) {
                this.messageState = mState.bevorFirstReading;
                check = true;
            }
        }

        if (
            this.cur == 0
            && this.min > this.counterValue
            && this.max == 0
            && this.minDate
            && formDate > this.minDate

        ) {
            this.messageState = mState.newCounter;
            check = true;
        }

        if ((this.cur > this.counterValue) && this.max == 0) {
            if (formDate.getTime() === this.curDate?.getTime()) {
                this.messageState = mState.newCounter;
                check = true;
            }
        }

        if (this.newCounterInput.checked) {
            check = false;
            if (this.counterValue > this.max) {
                check = true;
                this.messageState = mState.outOfRange;
            }
        }

        if (check) {
            this.valid = false;
            if (this.newCounterInput) {
                this.setEventListenerToNewCounter();
            }
            this.setMessage();
        } else {
            this.removeMessage()
            this.valid = true;
            this.counter.dataset.valid = 'true';
        }
        this.checkValid();
    }

    hasValue(): boolean {
        return !!(this.counter && this.counter.value && parseInt(this.counter.value) >= 0);
    }

    isValid(): boolean {
        return this.valid;
    }

    checkValid() {
        let counters: CounterMap | null = null;
        this.toggleSubmitDisabled();
        if (this.formName) {
            const form = window.formCounterMap.get(this.formName);
            if (form && form.getCounters().size) {
                counters = form.getCounters();
            }
        }

        let valid = true;

        if (counters) {
            counters.forEach(counter => {
                if (!counter.valid && counter.hasValue()) {
                    valid = false;
                }
            });
        }
        if (valid) {
            this.toggleSubmitDisabled(false);
        }
    }

    setDataAttributes(result: TriggerResponse) {
        if (this.counter) {
            this.counter.setAttribute('data-min-date', '');
            this.counter.setAttribute('data-max-date', '');
            this.counter.setAttribute('data-cur-date', '');
            this.minDate = null;
            this.maxDate = null;
            this.curDate = null;

            this.min = parseInt(result.min);
            this.max = parseInt(result.max);
            this.cur = parseInt(result.cur);
            this.maxIsNewCounter = result.max_is_new_counter ?? false;

            this.counter.setAttribute('data-min-counter', result.min);
            this.counter.setAttribute('data-max-counter', result.max);
            this.counter.setAttribute('data-cur-counter', result.cur);
            this.counter.setAttribute('data-max-is-new-counter', result.max_is_new_counter ? 'true' : 'false');


            if (result.min_date?.length) {
                this.minDate = new Date(result.min_date);
                this.counter.setAttribute('data-min-date', this.minDate.toLocaleDateString("de-DE"));
            }

            if (result.max_date?.length) {
                this.maxDate = new Date(result.max_date);
                this.counter.setAttribute('data-max-date', this.maxDate.toLocaleDateString("de-DE"));
            }

            if (result.cur_date?.length) {
                this.curDate = new Date(result.cur_date);
                this.counter.setAttribute('data-cur-date', this.curDate.toLocaleDateString("de-DE"));
            }
            this.toggleSubmitDisabled();
            this.removeMessage();

            if (this.form) {
                if ("1" !== this.form.getAttribute('edited')) {
                    this.counter.value = '';
                } else {
                    if (this.formName?.length) {
                        const counterForm = window.formCounterMap.get(this.formName);
                        if (counterForm != undefined && counterForm.getFormData()) {
                            const formData = counterForm.getFormData();

                            if (formData[this.counterName + 'IsNewCounter'] === true) {
                                this.messageState = mState.newCounter;
                                this.toggleMessage();
                                this.newCounterInput.checked = true;
                                this.setEventListenerToNewCounter();
                            }
                        }
                    }
                }
            }
        }
    }

    setEventListenerToNewCounter(): void {
        this.newCounterInput.addEventListener('click', (e) => ((counter: Counter) => {
            if (this.newCounterInput.checked) {
                this.valid = true;
                if (this.counter)
                    this.counter.dataset.valid = 'true';

                if (this.message)
                    this.message.innerHTML = '';
                this.checkValid();
            } else {
                this.valid = false;
                if (this.counter)
                    this.counter.dataset.valid = 'false';

                if (this.message)
                    this.setMessage();
                this.checkValid();
            }
        })(this));
    }

    toggleSubmitDisabled(hide: boolean = true) {

        this.formSubmit.setAttribute('disabled', 'disabled');

        if (this.form?.hasAttribute('edited')) {
            this.formSubmit.removeAttribute('disabled');
        }

        if (!hide)
            this.formSubmit.removeAttribute('disabled');

    }

    toggleMessage(show: boolean = false) {
        if (this.message) {
            if (this.message.innerHTML.length) {
                this.message.classList.remove('d-none');
            } else {
                this.message.classList.add('d-none');
            }
        }

        if (this.messageState == mState.newCounter || this.newCounterInput.checked) {
            this.inputWrapper.classList.remove('col-8');
            this.inputWrapper.classList.add('col-5');
            if (this.colWidth != 4) {
                this.newCounter.classList.remove('col-4');
                this.newCounter.classList.add('col-' + this.colWidth);
            }
            this.newCounter.classList.remove('d-none');
        } else {
            this.inputWrapper.classList.remove('col-5');
            this.inputWrapper.classList.add('col-8');
            this.newCounter.classList.add('d-none');
        }
    }

    removeMessage() {
        if (this.message) {
            this.message.innerHTML = '';
            this.messageState = mState.noMessage
            this.toggleMessage();
            return
        }
        this.createMessage();
    }

    setMessage() {
        if (!this.message)
            this.createMessage();

        if (this.message) {
            let message = '';
            if (this.messageState == mState.outOfRange) {
                message = 'Bitte geben Sie einen Zählerstand größer <span class="fw-bold">' + this.min + '</span> ';
                if (this.max)
                    message += 'und kleiner <span class="fw-bold">' + this.max + '</span>';

                message += ' ein!<br/>';
            }
            if (this.messageState == mState.newCounter) {
                message = 'Bitte geben Sie einen Zählerstand größer <span class="fw-bold">' + (this.cur > 0 ? this.cur : this.min) + '</span> ein!<br/>';
                message += 'Sollten Sie einen neuen Zähler installiert haben aktivieren Sie bitte die Checkbox [neuer Zähler].';
            }


            if (this.messageState == mState.bevorFirstReading) {
                let date = this.minDate ?? this.maxDate ?? new Date();
                message = 'Eingaben vor dem ' + date.toLocaleDateString("de-DE") + ' sind nicht möglich';
            }

            if (this.newCounterInput.checked && this.messageState == mState.outOfRange) {
                message = 'Bitte geben Sie einen Zählerstand kleiner <span class="fw-bold">' + this.max + '</span> ein!<br/>';
            }
            this.message.innerHTML = message;
        }
        this.toggleMessage();
    }

    createMessage() {
        let messageRow = document.createElement('div');
        messageRow.classList.add('row', 'messageRow');
        let messageCol = document.createElement('div');
        messageCol.classList.add('col', 'message', 'text-danger', 'd-none');
        messageRow.append(messageCol)
        this.inputFrame.append(messageRow);
        this.message = messageCol;
    }

}